export const countryResidence = (state) => state.countryResidence;

export default {
  countryResidence,
};
